import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { AreaInfoResponseData } from '@/store/slices/stagesSlice/interfaces'
import { AreaPageMenu } from '@/components/pages/AreaPageModern/components/AreaPageMain/components/AreaPageMenu/AreaPageMenu'
import { AreaPageFindCar } from '@/components/pages/AreaPageModern/components/AreaPageMain/components/AreaPageFindCar/AreaPageFindCar'
import { getCarsByNumber } from '@/store/slices/stagesSlice/stagesSlice'
import { RootState } from '@/store'
import { getFormattedCarNumber } from '@/helpers/getFormattedCarNumber'
import { useCarActions } from '@/helpers/hooks/useCarActions'
import styles from './AreaPageMain.module.scss'
import { MobileApp } from '@/components/MobileApp/MobileApp'
import { SliderPromotions } from '@/components/SliderPromotions/SliderPromotions'

export const AreaPageMain = ({
  area,
  areaId,
}: {
  area: AreaInfoResponseData | null
  areaId: string
}) => {
  const reduxState = useSelector<RootState, RootState>(state => state)
  const [carNumber, setCarNumber] = useState('')
  const findCarInputRef = useRef<HTMLInputElement>(null)

  const { loading: findStageLoading, error: findStageError } = getCarsByNumber(
    reduxState,
    carNumber,
  )
  const numberError = findStageError?.number?.[0]

  const {
    strictSearchLoading,
    strictSearchError,
    handleStageButtonClick,
    handleSubscriptionButtonClick,
    handleEventButtonClick,
    handleFinesButtonClick,
  } = useCarActions({ area, areaId, carNumber })

  useEffect(() => {
    const number = getFormattedCarNumber()
    setCarNumber(number)
  }, [])

  const handleSliderSwipe = () => {
    findCarInputRef.current?.blur()
  }

  return (
    <main className={styles.main}>
      <div className={styles.mobileApp}>
        <MobileApp />
      </div>
      <div className={styles.containerSlider}>
        <SliderPromotions onSwipe={handleSliderSwipe} />
      </div>
      <AreaPageFindCar
        ref={findCarInputRef}
        area={area}
        carNumber={carNumber}
        setCarNumber={setCarNumber}
        error={numberError || strictSearchError}
      />
      <AreaPageMenu
        isShowStageButton={area?.show_rates}
        isShowSubscriptionButton={area?.show_subscriptions}
        isShowEventButton={area?.show_events}
        handleStageButtonClick={handleStageButtonClick}
        handleSubscriptionButtonClick={handleSubscriptionButtonClick}
        handleEventButtonClick={handleEventButtonClick}
        handleFinesButtonClick={handleFinesButtonClick}
        isFindStageLoading={findStageLoading}
        isStrictSearchLoading={strictSearchLoading}
        isDisabled={carNumber.length < 3}
      />
    </main>
  )
}
